export default [
  {
    number: 26,
    class: 'muted',
    title: ''
  },
  {
    number: 27,
    class: 'muted',
    title: ''
  },
  {
    number: 28,
    class: 'muted',
    title: ''
  },
  {
    number: 29,
    class: 'muted',
    title: ''
  },
  {
    number: 30,
    class: 'muted',
    title: ''
  },
  {
    number: 31,
    class: 'muted',
    title: ''
  },
  {
    number: 1,
    class: 'hackathon',
    title: 'HackathonUSP'
  },
  {
    number: 2,
    class: '',
    title: ''
  },
  {
    number: 3,
    class: '',
    title: ''
  },
  {
    number: 4,
    class: '',
    title: ''
  },
  {
    number: 5,
    class: '',
    title: ''
  },
  {
    number: 6,
    class: '',
    title: ''
  },
  {
    number: 7,
    class: '',
    title: ''
  },
  {
    number: 8,
    class: '',
    title: ''
  },
  {
    number: 9,
    class: '',
    title: ''
  },
  {
    number: 10,
    class: '',
    title: ''
  },
  {
    number: 11,
    class: '',
    title: ''
  },
  {
    number: 12,
    class: '',
    title: ''
  },
  {
    number: 13,
    class: '',
    title: ''
  },
  {
    number: 14,
    class: '',
    title: ''
  },
  {
    number: 15,
    class: '',
    title: ''
  },
  {
    number: 16,
    class: '',
    title: ''
  },
  {
    number: 17,
    class: '',
    title: ''
  },
  {
    number: 18,
    class: '',
    title: ''
  },
  {
    number: 19,
    class: '',
    title: ''
  },
  {
    number: 20,
    class: 'off',
    title: 'Corpus Christi - Não haverá aula'
  },
  {
    number: 21,
    class: 'off',
    title: 'Recesso - Não haverá aula'
  },
  {
    number: 22,
    class: 'off',
    title: 'Recesso - Não haverá aula'
  },
  {
    number: 23,
    class: '',
    title: ''
  },
  {
    number: 24,
    class: '',
    title: ''
  },
  {
    number: 25,
    class: '',
    title: ''
  },
  {
    number: 26,
    class: '',
    title: ''
  },
  {
    number: 27,
    class: '',
    title: ''
  },
  {
    number: 28,
    class: '',
    title: ''
  },
  {
    number: 29,
    class: '',
    title: ''
  },
  {
    number: 30,
    class: '',
    title: ''
  },
  {
    number: 1,
    class: 'muted',
    title: ''
  },
  {
    number: 2,
    class: 'muted',
    title: ''
  },
  {
    number: 3,
    class: 'muted',
    title: ''
  },
  {
    number: 4,
    class: 'muted',
    title: ''
  },
  {
    number: 5,
    class: 'muted',
    title: ''
  },
  {
    number: 6,
    class: 'muted',
    title: ''
  },
]